__turbopack_context__.v({
  "acceptanceCard": "dfAuRa_acceptanceCard",
  "acceptanceDescription": "dfAuRa_acceptanceDescription",
  "legalLinks": "dfAuRa_legalLinks",
  "termsSettingsPanel": "dfAuRa_termsSettingsPanel",
});
